import { createSlice } from "@reduxjs/toolkit";

export const CountryState = createSlice({
  name: "countryState",
  initialState: {
    check: false,
    countryStateMenu: {},
  },
  reducers: {
    CountryStateAction: (state, action) => {
      state.check = true;
      state.countryStateMenu = action.payload;
    },
  },
});

export const { CountryStateAction, updateCountryStateAction } =
  CountryState.actions;

export default CountryState.reducer;
